import { extendTheme } from "@chakra-ui/react"

export const theme = extendTheme({
  fonts: {
    heading: "Gotham A, Gotham B, sans-sarif",
    body: "Gotham A, Gotham B, sans-sarif"
  },
  colors: {
    carrotOrange: {
      50: "#FCF3E5",
      100: "#FCF3E5",
      200: "#FAE6CC",
      300: "#FAE6CC",
      400: "#FAE6CC",
      500: "#E48400",
      600: "#C97500",
      700: "#C97500",
      800: "#C97500",
      900: "#C97500"
    },
    tooltipBlack: "#333333",
    medBlue: "#417091",
    selectActiveOption: "#FEF9F2",
    selectFocusedOption: "#D6E5FF",
    warningMessage: "#C17E44",
    warningHighlight: "#BA804D"
  }
})
